<template>
  <side-bar
    v-show="PostCreateSidebar"
    position-right
    class="z99-5 max-w25 mobile-createpostsidebar mobile-widfull hrcydivwfull"
  >
    <div v-show="currentPage =='home'">
      <div class="flex sidebar-topfixpart bg-primary justify-between p-4">
        <h2 class="h2-class font-semibold text-white">ADD POST</h2>

        <feather-icon
          icon="XIcon"
          @click="CrossPressed()"
          class="cursor-pointer text-white"
          svgClasses="w-6"
        ></feather-icon>
      </div>
      <div class="p-4 scroll-85vh">
        <b-form>
          <div class="mb-4">
            <base-input>
              <textarea
                placeholder="Write a comment..."
                class="form-control form-control-muted"
                rows="3"
                v-model="text"
              ></textarea>
            </base-input>
            <link-prevue
              :apiUrl="$apiUrl + '/post/urlParser'"
              :url="urls[0]"
            ></link-prevue>
          </div>

          <div class="category">
            <h2 class="font-bold">News Feeds</h2>
            <div class="mt-4">
              <div class="grid grid-cols-2 md:gap-4 lg:gap-4 gap-2 col-span">
                <b-card
                  class="cust-shadow cursor-pointer"
                  no-body
                  v-for="(item, index) in feeds"
                  :key="'item-' + index"
                  @click="setPostType(item)"
                >
                  <div class="md:p-4 lg:p-4 p-2 flex items-center">
                    <div
                      class="rounded-full md:w-10 lg:w-10 w-6 md:h-10 lg:h-10 h-6 flex justify-center items-center bg-primary-tranparent"
                    >
                      <feather-icon
                        :icon="item.icon"
                        class="text-primary"
                        svgClasses="md:w-4 lg:w-4 w-3"
                      ></feather-icon>
                    </div>
                    <small class="font-bold pl-3">{{ item.text }}</small>
                  </div>
                </b-card>
              </div>
              <base-button
                block
                v-if="text"
                type="primary"
                :disabled="!!!text"
                class="rounded-none w-full RadiusBtn m-auto font-semibold text-white mt-16 hi"
                @click="
                  $store.commit('posts/SET_CURRENT_PAGE', 'Choose Channel')
                "
                >CHOOSE CHANNEL</base-button
              >
            </div>
          </div>
        </b-form>
      </div>
      <!-- <footer
        class="
          footer-fix
          md:fixed
          lg:fixed
          bottom-0
          md:w-1/4
          lg:w-1/4
          w-full
          mobile-sidebarfooter
        "
      >
        <base-button
          block
          type="primary"
          :disabled="!!!text"
          class="rounded-none font-semibold text-white"
          @click="$store.commit('posts/SET_CURRENT_PAGE', 'Choose Channel')"
          >CHOOSE CHANNEL</base-button
        >
      </footer> -->
    </div>
    <!-- <div class="mb-4" v-show="showUploader"> -->

    <Poll v-if="currentPage == 'Poll'" />
    <ImagePost v-if="mediaPages.includes(currentPage)" />
    <div class="mb-4" v-show="currentPage == 'Choose Channel'">
      <ChoosePlan @closeSidebar="CrossPressed()" />
    </div>
    <!-- </div> -->
    <!-- <div class="mb-4" v-show="showUploader"> -->
    <Discussion v-if="currentPage == 'Discussion'" />
    <!-- </div> -->
  </side-bar>
</template>
<script>
import LinkPrevue from "link-prevue";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import ImagePost from "./ImagePost.vue";
import Poll from "./Pollpage.vue";
import Discussion from "./Discussionpage.vue";
import ChoosePlan from "./ChoosePlan.vue";
import { mapState } from "vuex";

export default {
  watch: {
    PostCreateSidebar(val) {
      if (val) {
        this.$store.commit("posts/RESET_CREATE_POST");
        const params = new URLSearchParams();
        params.append("rights", "posting");
        this.$store.dispatch("posts/GetPostingChannel", params);
        this.$store.commit("posts/SET_POST", {
          key: "type",
          value: "text",
        });
        this.$store.commit("posts/SET_CURRENT_PAGE", "home");
      }
    },
    urls(val) {
      if (val.length) {
        this.$store.commit("posts/SET_POST", {
          key: "type",
          value: "url",
        });
        this.$store.commit("posts/SET_POST", {
          key: "url",
          value: val[0],
        });
      }
    },
    text(val) {
      this.$store.commit("posts/SET_POST", { key: "text", value: val });
      this.getURLS();
    },
  },
  data() {
    return {
      
      feeds: [
        {
          icon: "ImageIcon",
          text: "Image Post",
          value: "image",
        },
        {
          icon: "VideoIcon",
          text: "Video Post",
          value: "video",
        },
        {
          icon: "MicIcon",
          text: "Podcast",
          value: "audio",
        },
        {
          icon: "ActivityIcon",
          text: "Poll",
          value: "poll",
        },
        // {
        //   icon: "CoffeeIcon",
        //   text: "Discussion"
        // }
      ],
      showUploader: false,
      text: "",
      urls: [],
      mediaPages: ["Image Post", "Video Post", "Podcast"],
    };
  },
  components: {
    ImagePost,
    Poll,
    Discussion,
    ImagePost,
    ChoosePlan,
    LinkPrevue,
  },
  computed: {
    
    ...mapState("posts", {
      currentPage: "currentPage",
      previousPage: "previousPage",
    }),
  },
  methods: {
    setPostType(item) {
      const { text, value } = item;
      this.$store.commit("posts/SET_CURRENT_PAGE", text);
      this.$store.commit("posts/SET_POST", { key: "type", value: value });
    },
    CrossPressed() {
      this.text = "";
      this.urls = [];
      this.$emit("closeModal",true)
    },
    getURLS() {
      var uri_pattern =
        /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.\-]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^\s`!()\[\]{};:'".,<>?«»“”‘’]))/gi;
      const matches = this.text.match(uri_pattern);
      if (matches && matches.length) {
        matches.forEach((element) => {
          if (this.urls.indexOf(element) === -1) this.urls.push(element);
        });
      }
    },
  },
  props:{
    PostCreateSidebar:{
      type:Boolean
    }
  }
};
</script>
